// extracted by mini-css-extract-plugin
export default {"lhs":"DashboardPage_lhs__AohUR","section":"DashboardPage_section__l8cek","profile":"DashboardPage_profile__JcI6v","txtx":"DashboardPage_txtx__KmVfG"};